/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Actions_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Speaker actions" |
*
* @param {Speakers_Actions_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_actions_aria_label = /** @type {((inputs?: Speakers_Actions_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Actions_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actions d'intervenant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprechermaßnahmen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Azioni dell'oratore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Действия выступающего")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acciones del orador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发言人行动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーの行動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ता की कार्रवाइयां")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ações do orador")
	return /** @type {LocalizedString} */ ("Speaker actions")
});